<template lang="pug">
.auth_frame
  .auth_frame_qr
    i18n(:path="isRegisterVisibility ? 'misc.auth.account.complete.register' : 'misc.auth.account.complete.registration'" tag="h3" class="auth_frame_title")
    .auth_frame_qr_content
      i18n(:path="'misc.auth.open.camera'" tag="span" class="auth_frame_qr_content_item")
      i18n(:path="isRegisterVisibility ? 'misc.auth.scan.qr.register' : 'misc.auth.scan.qr'" tag="span" class="auth_frame_qr_content_item")
      i18n(:path="isRegisterVisibility ? 'misc.auth.download.app.register' : 'misc.auth.download.app'" tag="span" class="auth_frame_qr_content_item")
    .auth_frame_qr_code
      qrcode-vue(:value="value" :size="size" level="H")
  .auth_frame_img
    img(:src='selectedAppView' alt="Selected-App-View")
</template>
<script>
import appView from '@/assets/appView.png';
import appViewEn from '@/assets/appViewEn.png';
import appViewRu from '@/assets/appViewRu.png';
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'AppFrame',
  components: {
    QrcodeVue,
  },
  props: {
    isRegisterVisibility: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      value: 'https://sbplus.mpay.az/mpay-link',
      size: 202,
      userAgent: window.navigator.userAgent,
      appView,
      appViewEn,
      appViewRu,
    };
  },
  computed: {
    selectedAppView() {
      if (localStorage.getItem('lang')) {
        if (localStorage.getItem('lang').toLowerCase() === 'en') {
          return appViewEn;
        }

        if (localStorage.getItem('lang').toLowerCase() === 'ru') {
          return appViewRu;
        }
      }

      return appView;

    },
    // isMobile() {
    //   return this.$vuetify.breakpoint.mobile;
    // },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/auth.scss';
.auth_frame {
    display: flex;
    align-items: center;
    gap: 32px;
    align-items: flex-end;
    max-width: min-content;
    width: 100%;
    text-align: left;
    border-radius: 15px;
    padding: 32px;
    border: 1.38px solid #E0E1E4;
    background: radial-gradient(42.65% 42.65% at 78.5% 54.18%, #C4D4E7 0%, #FAFAFA 100%);
    &_title {
      font-size: 16px;
      font-weight: 500;
      line-height: 150%;
      margin-bottom: 16px;
    }
    &_qr {
      display: flex;
      flex-direction: column;
      &_content {
        &_item {
          font-weight: 400;
          font-size: 14px;
          line-height: 125%;
          color: #4B4B4B;
          display: block;
          &:nth-child(2n) {
            margin: 10px 0;
          }
        }
      }
      &_code {
        border-radius: 16px;
        background: white;
        padding: 12px;
        margin-top: 24px;
        box-shadow: -2px 0px 6px 0px #00000014;
        max-width: 226px;
      }
    }
    &_img {
      box-shadow: inset 0 -2px 6px 0 rgba(17, 43, 69, .35), 0 30px 60px -30px rgba(0, 0, 0, .3), 0 50px 100px -20px rgba(50, 50, 93, .25);
      padding: 8px 9px;
      background-color: #F6F9FC;
      border-radius: 20px;
      img {
        width: 152px;
        height: 330px;
        display: flex;
      }
    }
}
@media (max-width: 900px) {
  .auth {
    &_form {
      padding: 25px;
    }
    &_frame {
      padding: 16px;
    }
  }
}
@media (max-width: 800px) {
  .auth {
    &_frame {
      display: none;
      max-width: 100%;
      display: flex;
      justify-content: center;
      gap: 5px;
      padding: 4px 0 24px;
      border-radius: 0 0 20px 20px;
      border: 1.38px solid transparent;
      background: white;
      &_qr, &_title, &_img{
        display: none;
      }
    }
  }
}
@media (max-width: 435px) {
  .auth_frame_mobile {
    flex-direction: column;
    gap: 0;
  }
}
</style>
